
const getMenuNameText = function () {
    return "Nombre descriptivo del menú. No se va a mostrar en la web.";
}

const getMenuTitleText = function () {
    return "Título traducido del menú. Esto sólo se tiene en cuenta en menús de tipo 'Submenú'. Sí se va a mostrar en la web.";
}

const getMenuDescriptionText = function() {
    return "Descripción del menú. No se va a mostrar en la web.";
}

const getMenuCssClassText = function() {
    return "Clase CSS utilizada para personalizar el menú.";
}
const getMenuPositionText = function() {
    return "Posición del menú en relación a otros. Sólo se tiene en cuenta si es un submenú.";
}

const getMenuTypeText = function () {
    return "Tipo de menú: header o footer.";
}

const getItemNameText = function () {
    return "Nombre descriptivo del elemento. No se va a mostrar en la web.";
}

const getItemCssClassText = function () {
    return "Clase CSS utilizada por el departamento de Marketing para medir clicks y visualizaciones.";
}

const getItemHtmlText = function () {
    return "Código html (svg, imagen, etc..) a mostrar dentro del elemento.";
}

const getItemHtmlBehaviourText = function () {
    return "Permite modificar el comportamiento del código html (alineado a la izquierda, sustituye al texto, etc..)." +
        " Se ignora si no hay contenido html introducido.";
}

const getItemMobileText = function () {
    return "El elemento se muestra en mobile.";
}

const getItemDesktopText = function () {
    return "El elemento se muestra en desktop.";
}

const getItemTabletText = function () {
    return "El elemento se muestra en tablet.";
}

const getItemNoFollowText = function () {
    return "Añade al enlace el tag 'rel=nofollow'.";
}

const getItemTargetBlankText = function () {
    return "El enlace se abre en nueva ventana.";
}

const getItemUserCountryText = function () {
    return "El elemento se muestra sólo si el cliente accede desde alguno de los siguientes paises:";
}

const getItemValidDatesText = function () {
    return "El elemento se muestra sólo durante los siguientes periodos de tiempo:";
}

const getItemLanguagesText = function () {
    return "El elemento se muestra sólo en los siguientes idiomas:";
}

const getItemIsAdminReservedText = function () {
    return "El elemento sólo lo puede modificar un usuario admin.";
}

const getItemIsDisabledText = function () {
    return "Con esta opcíon seleccionada el elemento se desactiva y viceversa.";
}

const getItemContainerClassText = function () {
    return "Clase opcional CSS para personalizar el contenedor HTML del elemento.";
}

const getItemSectionIdTextText = function () {
    return "Id opcional de sección web del elemento del menú. Utilizado para resaltar el elemento seleccionado en la web.";
}

const getItemSubSectionIdText = function () {
    return "Id opcional de subsección web del elemento del menú. Utilizado para resaltar el elemento seleccionado en la web.";
}

const getItemsubMenuText = function () {
    return "Se puede seleccionar otro menú para desplegarse en este elemento.";
}

const getItemActiveText = function () {
    return "Sólo se van a mostrar en la web elementos activos.";
}

const getDraftHelp = function () {
    return "Si el menú está en modo 'borrador' los ultimos cambios todavía no se verán en producción.";
}

const getMenuIsDisabledText = function () {
    return "Con esta opcíon seleccionada el menú se desactiva y viceversa.";
}

const getMenuActiveText = function () {
    return "Sólo se van a mostrar en la web menú activos.";
}

const getParentWebMenuItemText = function() {
    return "Elemento desde el cual se va a desplegar el menú actual. Esto sólo se tiene en cuenta en menús de tipo 'Submenú'";
}

const getTitleLabelIdText = function() {
    return "Id de etiqueta del titulo del menú mostrado en la web. Esto sólo se tiene en cuenta en menús de tipo 'Submenú'";
}

export default {
    getMenuNameText,
    getMenuDescriptionText,
    getMenuTypeText,
    getMenuTitleText,
    getItemNameText,
    getItemCssClassText,
    getItemHtmlText,
    getItemHtmlBehaviourText,
    getItemMobileText,
    getItemDesktopText,
    getItemTabletText,
    getItemNoFollowText,
    getItemTargetBlankText,
    getItemUserCountryText,
    getItemValidDatesText,
    getItemLanguagesText,
    getItemIsAdminReservedText,
    getItemIsDisabledText,
    getItemContainerClassText,
    getItemSectionIdTextText,
    getItemSubSectionIdText,
    getItemsubMenuText,
    getItemActiveText,
    getDraftHelp,
    getMenuIsDisabledText,
    getMenuActiveText,
    getParentWebMenuItemText,
    getTitleLabelIdText,
    getMenuPositionText,
    getMenuCssClassText
};
